module.exports = __webpack_public_path__ + "static/media/PC-MVC-TechBlog.732b1c9a.jpg";